import {
  CalendarIcon,
  CheckIcon,
  ChevronRightIcon,
  DeviceMobileIcon,
  InfoIcon,
  KebabHorizontalIcon,
  MailIcon,
  PencilIcon,
  PersonIcon,
  PlusIcon,
  StarIcon,
  TrashIcon,
} from "@primer/octicons-react";
import {
  ActionList,
  ActionMenu,
  Box,
  Button,
  Dialog,
  IconButton,
  Label,
  Text,
} from "@primer/react";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { API_QUANHEGIADINH_ENDPOINT, quanHeGiaDinhApi } from "../../../api/quanHeGiaDinhApi";
import TextTranslated from "../../../components/text";
import MyButton from "../../../components/ui/button/Button";
import UserAvatar from "../../../components/user-avatar";
import { useCommonContext } from "../../../contexts/common";
import QuanHeGiaDinhEditModal from "./detail-modal/QuanHeGiaDinhEditModal";
import DataTable from "../../../components/ui/data-table/DataTable";

// Types
export interface HocSinh {
  id: number;
  ho_ten: string;
  ma_hs: string;
  ma_tn: string;
  ngay_sinh: string;
  dm_gioitinh_id: number;
  gioi_tinh: string;
  ten_he: string;
  ten_lop: string;
  trang_thai: string;
}

interface PhuHuynh {
  id: number;
  ho_ten: string;
  email: string;
  dien_thoai: string;
  quan_he: string;
}

interface QuanHeGiaDinh {
  id: number;
  dm_quanhe_id: number;
  ts_hocsinh_ace?: HocSinh;
  ts_phuhuynh?: PhuHuynh;
  is_uutien: boolean;
}

interface ApiResponse<T> {
  is_success: boolean;
  data: T;
  message?: string;
}

const quanHeGroups = [
  { idx: 1, text: "Phụ huynh", dm_quanhe_ids: [1, 2] },
  { idx: 2, text: "Anh/ Chị/ Em", dm_quanhe_ids: [5, 6] },
  { idx: 3, text: "Khác", dm_quanhe_ids: [0, 3, 4] },
];

interface Props {
  hocSinh: HocSinh;
  height?: number;
}

const QuanHeGiaDinhHocSinh: React.FC<Props> = ({ hocSinh }) => {
  const { checkAccesiableTo } = useCommonContext();

  const [isLoading, setIsLoading] = useState(false);
  const [quanHeGiaDinhs, setQuanHeGiaDinhs] = useState<QuanHeGiaDinh[]>([]);
  const [editingQuanHeGiaDinh, setEditingQuanHeGiaDinh] = useState<
    QuanHeGiaDinh | undefined
  >();
  const [isShowDetailModal, setIsShowDetailModal] = useState(false);
  const [isShowDeleteConfirm, setIsShowDeleteConfirm] = useState(false);

  const componentDidMount = useRef(false);

  // Phân quyền API
  // const canView = checkAccesiableTo(`${API_QUANHEGIADINH_ENDPOINT}/hoc-sinh/{ts_hocsinh_id}`, "GET");
  // const canInsert = checkAccesiableTo(API_QUANHEGIADINH_ENDPOINT, "POST");
  // const canUpdate = checkAccesiableTo(API_QUANHEGIADINH_ENDPOINT, "PUT");
  // const canDelete = checkAccesiableTo(`${API_QUANHEGIADINH_ENDPOINT}/{id}`, "DELETE");
  // const canViewDetail = checkAccesiableTo(`${API_QUANHEGIADINH_ENDPOINT}/{id}`, "GET");

    const canView = true;
  const canInsert = true;
  const canUpdate = true;
  const canDelete = true;
  const canViewDetail = true;

  const handleGetQuanHeGiaDinhs = useCallback(async () => {
    if (!canView) return;

    setIsLoading(true);
    try {
      const res = await quanHeGiaDinhApi.selectByHocSinh(hocSinh.id);
      if (componentDidMount.current && res.is_success) {
        setQuanHeGiaDinhs(res.data);
      }
    } catch (error) {
      console.error("Failed to fetch:", error);
    } finally {
      setIsLoading(false);
    }
  }, [canView, hocSinh.id]);

  useEffect(() => {
    if (!canView) return;
    componentDidMount.current = true;
    handleGetQuanHeGiaDinhs();
    return () => {
      componentDidMount.current = false;
    };
  }, [hocSinh, canView, handleGetQuanHeGiaDinhs]);

  const handleDeleteQuanHeGiaDinh = async () => {
    if (!canDelete || !editingQuanHeGiaDinh) return;

    try {
      const res = await quanHeGiaDinhApi.delete(editingQuanHeGiaDinh.id);
      if (componentDidMount.current && res.is_success) {
        handleGetQuanHeGiaDinhs();
        setIsShowDeleteConfirm(false);
      } else {
        throw new Error(res.message || "Delete failed");
      }
    } catch (error) {
      //   showNotify({
      //     type: 'error',
      //     text: 'Có lỗi xảy ra'
      //   });
    }
  };
  console.log({
    quanHeGiaDinhs
  });




  // Kiểm tra quyền truy cập
  if (!canView) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 4 }}>
        <Text color="fg.muted">Bạn không có quyền xem thông tin quan hệ gia đình</Text>
      </Box>
    );
  }

  return (
    <Box>
      <DataTable
        data={quanHeGiaDinhs.map(x => ({
          ...x.ts_phuhuynh,
          quanhe_id: x.id, // Giữ ID của quan hệ gia đình
          dm_quanhe_id: x.dm_quanhe_id,
          is_uutien: x.is_uutien
        }))}
        isLoading={isLoading}
        title={"Phụ huynh"}
        searchEnable
        emptyComponent={
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", color: "fg.muted" }}>
            Không có dữ liệu
          </Box>
        }
        actionComponent={
          canInsert && (
            <Box sx={{
              display: "flex",
            }}>
              <MyButton text="Base.Label.AddNew" leadingVisual={PlusIcon}
                size="medium"
                variant="primary"
                onClick={() => {
                  setEditingQuanHeGiaDinh(undefined);
                  setIsShowDetailModal(true);
                }}
              />

            </Box>
          )
        }
        columns={[
          {
            id: "cmd",
            caption: "#",
            width: "50px",
            align: "center",
            cellRender: (quanHe: any) => {
              const hasEditPermission = canUpdate;
              const hasDeletePermission = canDelete && !quanHe.is_uutien;

              // Hiển thị box trống nếu không có quyền nào
              if (!hasEditPermission && !hasDeletePermission) {
                return <Box sx={{ m: -1 }}></Box>;
              }

              return (
                <Box sx={{ m: -1 }}>
                  <ActionMenu>
                    <ActionMenu.Anchor>
                      <IconButton
                        size="small"
                        icon={KebabHorizontalIcon}
                        variant="invisible"
                        aria-label="Open options menu"
                      />
                    </ActionMenu.Anchor>
                    <ActionMenu.Overlay>
                      <ActionList>
                        {hasEditPermission && (
                          <ActionList.Item onSelect={() => {
                            // Tìm lại object QuanHeGiaDinh đầy đủ từ danh sách
                            const fullQuanHe = quanHeGiaDinhs.find(x => x.id === quanHe.quanhe_id);
                            console.log("Edit clicked - quanHe.quanhe_id:", quanHe.quanhe_id);
                            console.log("Edit clicked - fullQuanHe:", fullQuanHe);
                            setEditingQuanHeGiaDinh(fullQuanHe);
                            setIsShowDetailModal(true);
                          }}>
                            <ActionList.LeadingVisual>
                              <PencilIcon />
                            </ActionList.LeadingVisual>
                            <TextTranslated value="Base.Label.Edit" />
                          </ActionList.Item>
                        )}
                        {hasDeletePermission && (
                          <>
                            {hasEditPermission && <ActionList.Divider />}
                            <ActionList.Item
                              variant="danger"
                              onSelect={() => {
                                // Tìm lại object QuanHeGiaDinh đầy đủ từ danh sách
                                const fullQuanHe = quanHeGiaDinhs.find(x => x.id === quanHe.quanhe_id);
                                setEditingQuanHeGiaDinh(fullQuanHe);
                                setIsShowDeleteConfirm(true);
                              }}
                            >
                              <ActionList.LeadingVisual>
                                <TrashIcon />
                              </ActionList.LeadingVisual>
                              <TextTranslated value="Base.Label.Delete" />
                            </ActionList.Item>
                          </>
                        )}
                      </ActionList>
                    </ActionMenu.Overlay>
                  </ActionMenu>
                </Box>
              );
            }
          },
          {
            dataField: "quan_he",
            caption: "Quan hệ",
            width: 200,
            isMainColumn: true

          },
          {
            dataField: "ho_ten",
            caption: "Họ tên",
            width: 150,
            isMainColumn: true

          },
          {
            dataField: "dien_thoai",
            caption: "Điện thoại",
          },
          {
            dataField: "email",
            caption: "Email",
          },
          {
            dataField: "is_uutien",
            caption: "Liên hệ chính",
            width: 120,
            align: "center",
            cellRender: (quanHe: any) => (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={quanHe.is_uutien}
                  readOnly
                  style={{
                    width: "16px",
                    height: "16px",
                    cursor: "not-allowed",
                    opacity: 0.7
                  }}
                />
              </Box>
            ),
          },



        ]}
      />

      {isShowDetailModal && (canInsert || canUpdate) && (
        <QuanHeGiaDinhEditModal
          ts_hocsinh_id={hocSinh.id}
          id={editingQuanHeGiaDinh != null ? editingQuanHeGiaDinh.id : 0}
          onSuccess={() => {
            setIsShowDetailModal(false);
            handleGetQuanHeGiaDinhs();
          }}
          onCancel={() => {
            setIsShowDetailModal(false);
          }}
        />
      )}
      {canDelete && (
        <Dialog
          isOpen={isShowDeleteConfirm}
          sx={{
            position: "fixed",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Dialog.Header>Lưu ý</Dialog.Header>
          <Box p={3}>
            <Text>Bạn có chắc chắn muốn xóa Quan hệ gia đình này?</Text>
            <Box display="flex" mt={3} justifyContent="flex-end">
              <Box mr={2}>
                <Button
                  variant="default"
                  onClick={() => setIsShowDeleteConfirm(false)}
                >
                  Đóng
                </Button>
              </Box>
              <Button variant="danger" onClick={handleDeleteQuanHeGiaDinh}>
                Xóa
              </Button>
            </Box>
          </Box>
        </Dialog>
      )}
    </Box>
  );
};
interface PhuHuynhListProps {
  quanHeGiaDinhs: QuanHeGiaDinh[];
  isAllowEditing: boolean;
  onEditClick: (quanHe: QuanHeGiaDinh) => void;
  onDeleteClick: (quanHe: QuanHeGiaDinh) => void;
}
const PhuHuynhList: React.FC<PhuHuynhListProps> = ({
  quanHeGiaDinhs,
  isAllowEditing,
  onEditClick,
  onDeleteClick,
}) => {
  return (
    <ActionList showDividers>
      {quanHeGiaDinhs.map((quanHe, index) => {
        const phuhuynh = quanHe.ts_phuhuynh;
        if (!phuhuynh) return null;

        return (
          <ActionList.Item
            key={index}
            sx={{
              py: 2,
              "&:hover": {
                backgroundColor: "canvas.subtle",
              },
            }}
          >
            <Box display="flex" alignItems="center" width="100%">
              <ActionList.LeadingVisual>
                <Box
                  sx={{
                    display: "flex", // Thay đổi từ inline-flex thành flex
                    alignItems: "center", // Thêm căn giữa
                    lineHeight: 1,
                  }}
                >
                  <UserAvatar fullName={phuhuynh.ho_ten} size="large" />
                </Box>
              </ActionList.LeadingVisual>

              <Box flex={1} sx={{ mb: 0, pl: 2 }}>
                <Box display="flex" alignItems="center">
                  <Text fontWeight="bold">{phuhuynh.ho_ten}</Text>
                  <Label sx={{ ml: 2 }} variant="success">
                    {phuhuynh.quan_he}
                  </Label>
                </Box>
                <ActionList.Description variant="block">
                  <Box display="flex" alignItems="center" mt={1}>
                    <Text fontSize={1}>
                      {phuhuynh.dien_thoai} - {phuhuynh.email}
                    </Text>
                  </Box>
                </ActionList.Description>
              </Box>

              <ActionList.TrailingVisual>
                <Box display="flex" alignItems="center">
                  {quanHe.is_uutien && (
                    <Box mr={3} display="flex" alignItems="center">
                      <StarIcon size={16} fill="gold" />
                      <Text ml={1} fontSize={1} fontWeight="bold">
                        Liên hệ chính
                      </Text>
                    </Box>
                  )}

                  {isAllowEditing && (
                    <ActionMenu>
                      <ActionMenu.Anchor>
                        <IconButton
                          icon={KebabHorizontalIcon}
                          variant="invisible"
                          aria-label="Open options menu"
                        />
                      </ActionMenu.Anchor>
                      <ActionMenu.Overlay>
                        <ActionList>
                          <ActionList.Item onSelect={() => onEditClick(quanHe)}>
                            <ActionList.LeadingVisual>
                              <PencilIcon />
                            </ActionList.LeadingVisual>
                            <TextTranslated value="Base.Label.Edit" />
                          </ActionList.Item>
                          {!quanHe.is_uutien && (
                            <>
                              <ActionList.Divider />
                              <ActionList.Item
                                variant="danger"
                                onSelect={() => onDeleteClick(quanHe)}
                              >
                                <ActionList.LeadingVisual>
                                  <TrashIcon />
                                </ActionList.LeadingVisual>
                                <TextTranslated value="Base.Label.Delete" />
                              </ActionList.Item>
                            </>
                          )}
                        </ActionList>
                      </ActionMenu.Overlay>
                    </ActionMenu>
                  )}
                </Box>
              </ActionList.TrailingVisual>
            </Box>
          </ActionList.Item>
        );
      })}
    </ActionList>
  );
};

interface PhuHuynhInfoProps {
  ts_phuhuynh: PhuHuynh;
  is_uutien: boolean;
  isAllowEditing: boolean;
  onDeleteClick: () => void;
  onEditClick: () => void;
  isSelected?: boolean;
  onToggleSelect?: (phuhuynh: PhuHuynh) => void;
}
const PhuHuynhInfo: React.FC<PhuHuynhInfoProps> = ({
  ts_phuhuynh,
  is_uutien,
  isAllowEditing,
  onDeleteClick,
  onEditClick,
  isSelected,
  onToggleSelect,
}) => {
  return (
    <Box>
      <Box display="flex" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center" flex={1}>
          {onToggleSelect && (
            <Box mr={2}>
              <IconButton
                icon={CheckIcon}
                variant={isSelected ? "primary" : "default"}
                aria-label={isSelected ? "Deselect parent" : "Select parent"}
                aria-checked={isSelected}
                onClick={() => onToggleSelect(ts_phuhuynh)}
              />
            </Box>
          )}
          <Text fontWeight="bold" fontSize={2}>
            {ts_phuhuynh.ho_ten}
          </Text>
          <Label variant="accent" sx={{ ml: 2 }}>
            {ts_phuhuynh.quan_he}
          </Label>
        </Box>
        {isAllowEditing && (
          <Box ml="auto">
            <ActionMenu>
              <ActionMenu.Anchor>
                <IconButton
                  icon={KebabHorizontalIcon}
                  variant="invisible"
                  aria-label="Open options menu"
                />
              </ActionMenu.Anchor>
              <ActionMenu.Overlay>
                <ActionList>
                  <ActionList.Item onSelect={onEditClick}>
                    <ActionList.LeadingVisual>
                      <PencilIcon />
                    </ActionList.LeadingVisual>
                    <TextTranslated value="Base.Label.Edit" />
                  </ActionList.Item>
                  <ActionList.Divider />
                  <ActionList.Item variant="danger" onSelect={onDeleteClick}>
                    <ActionList.LeadingVisual>
                      <TrashIcon />
                    </ActionList.LeadingVisual>
                    <TextTranslated value="Base.Label.Delete" />
                  </ActionList.Item>
                </ActionList>
              </ActionMenu.Overlay>
            </ActionMenu>
          </Box>
        )}
      </Box>

      <Box display="flex" alignItems="center" mb={2}>
        <MailIcon size={16} />
        <Text ml={2}>Email: </Text>
        <Text fontWeight="bold" ml={1}>
          {ts_phuhuynh.email}
        </Text>
      </Box>

      <Box display="flex" alignItems="center" mb={2}>
        <DeviceMobileIcon size={16} />
        <Text ml={2}>Điện thoại liên hệ: </Text>
        <Text fontWeight="bold" ml={1}>
          {ts_phuhuynh.dien_thoai}
        </Text>
      </Box>

      <Box display="flex" alignItems="center">
        <Link to={`../../phu-huynh/${ts_phuhuynh.id}`} target="_blank">
          <Text>Xem lịch sử chăm sóc </Text>
          <ChevronRightIcon size={16} />
        </Link>
        {is_uutien && (
          <Text fontWeight="bold" ml="auto">
            Liên hệ chính
          </Text>
        )}
      </Box>
    </Box>
  );
};

interface HocSinhInfoProps {
  ts_hocsinh: HocSinh;
}

const HocSinhInfo: React.FC<HocSinhInfoProps> = ({ ts_hocsinh }) => {
  return (
    <Box>
      <Box display="flex" alignItems="center" mb={2}>
        <Text fontWeight="bold" fontSize={2}>
          {ts_hocsinh.ho_ten}
        </Text>
        <Label variant="accent">{ts_hocsinh.trang_thai}</Label>
      </Box>

      <Box display="flex" mb={2}>
        <Box flex={1}>
          <Text fontWeight="bold">{ts_hocsinh.ma_hs}</Text>
        </Box>
        <Box flex={1}>
          <Text>{ts_hocsinh.ma_tn}</Text>
        </Box>
      </Box>

      <Box display="flex" mb={2}>
        <Box flex={1} display="flex" alignItems="center">
          <CalendarIcon size={16} />
          <Text ml={2}>
            {moment(ts_hocsinh.ngay_sinh).format("DD/MM/YYYY")}
          </Text>
        </Box>
        <Box flex={1} display="flex" alignItems="center">
          <PersonIcon size={16} />
          <Text ml={2}>{ts_hocsinh.gioi_tinh}</Text>
        </Box>
      </Box>

      <Box display="flex">
        <Box flex={1}>
          <Text>Hệ {ts_hocsinh.ten_he}</Text>
        </Box>
        <Box flex={1}>
          <Text>Lớp {ts_hocsinh.ten_lop}</Text>
        </Box>
      </Box>
    </Box>
  );
};

export default QuanHeGiaDinhHocSinh;
